import React, { useEffect, useState } from "react";
import { VersionSwitcher, AppVersion } from "./components/VersionSwitcher";
import { ThemeProvider } from "./contexts/ThemeContext";
import { HarvardCV } from "./pages/HarvardCV";
import { WebPortfolio } from "./pages/WebPortfolio";

function getVersionFromHash(): AppVersion {
  const hash = window.location.hash.replace(/^#\/?/, "").toLowerCase();
  if (hash === "cv" || hash === "harvard" || hash === "pdf") return "harvard";
  return "web";
}

function App() {
  const [version, setVersion] = useState<AppVersion>(getVersionFromHash);

  useEffect(() => {
    const onHashChange = () => setVersion(getVersionFromHash());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return (
    <ThemeProvider>
      <div className="App">
        {version === "harvard" ? <HarvardCV /> : <WebPortfolio />}
        <VersionSwitcher current={version} />
      </div>
    </ThemeProvider>
  );
}

export default App;
